export const startGoogleLogin = (search = window.location.search) => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/" + search;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const INTAKE_KEY = "iv360_intake";
export const DRAFT_TOKEN_KEY = "iv360_draft_token";

export const readSession = (key) => {
  try {
    return JSON.parse(sessionStorage.getItem(key) || "null");
  } catch {
    return null;
  }
};
export const writeSession = (key, value) => sessionStorage.setItem(key, JSON.stringify(value));
